import { createEntityAdapter } from '@reduxjs/toolkit'

import { Constraint } from './models/Constraint'

export const constraintsAdapter = createEntityAdapter({
  selectId: (constraint: Constraint) => constraint.id,
})
